import { US_STATES } from "@/lib/constants";

export const StateSelect = ({ value, onChange, className = "", ...props }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={`w-full appearance-none bg-no-repeat ${className}`} {...props}>
    <option value="">Select state</option>
    {US_STATES.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
  </select>
);
